import styled from '@emotion/styled';
import { bodyB, bodyM, largeTitle, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: pre-line;

  background: #1f1837;
`;

export const Title = styled.span`
  ${title2};
  color: ${vars.neutral[0]};

  text-align: center;

  ${DESKTOP} {
    ${largeTitle};
    color: ${vars.neutral[0]};
  }
`;

export const Description = styled.p`
  ${bodyM};
  color: ${vars.neutral[50]};

  text-align: center;

  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[50]};
  }
`;

export const Button = styled.button`
  display: flex;
  min-width: 70px;
  padding: 13px 14px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 999px;
  width: 100%;
  ${bodyB}
  background: ${vars.brand.default};
  color: #fff;

  ${DESKTOP} {
    background: ${vars.brand.default};
    color: #fff;
  }
`;
